/** Prefijo público de la API — lo usan el backend (setGlobalPrefix), el proxy de Vite y Nginx. */
export const API_PREFIX = '/api';

/** Puerto de la API cuando el entorno no define PORT. Todos los puertos del proyecto son >= 5000. */
export const DEFAULT_API_PORT = 5001;

/** Idiomas soportados por la aplicación; el primero es el de reserva. */
export const SUPPORTED_LOCALES = ['es', 'en'] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];
